import { BgContainer, BgMet } from './background.styles'

const Background = () => {

  return  (
  <>
    <BgContainer>
      <BgMet></BgMet>
    </BgContainer>
  </>
);}

export default Background;